<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
    <b-form @submit.stop.prevent="guardar">
      <div >
        <b-tabs class="mr-3 ml-3">
          <b-tab class="p-0">
            <template #title>
              Datos de la Categoria Promoción
            </template>

            <div class="scrollPorTabs mt-1">
              <b-row class="mb-2">
                <b-col>
                  <p style="color: var(--color-dentalia); font-weight: 600" class="mt-2">Datos generales</p>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" md="5" lg="5">
                  <b-col>
                    <b-form-group align="left">
                      <label class="letter">Nombre de la categoria promoción <validacion/> </label>
                      <b-input-group size="sm">
                        <b-form-input
                            class="redondeo"
                            id="nombreCategoriaPromocion"
                            name="nombreCategoriaPromocion"
                            placeholder="Ingresa el nombre de la categoria promoción"
                            v-model="$v.objGuardar.nombreCategoriaPromocion.$model"
                            :state="validateState('nombreCategoriaPromocion')"
                            required
                        ></b-form-input>
                      </b-input-group>
                    </b-form-group>
                    <b-form-invalid-feedback :state="objGuardar.nombreCategoriaPromocion != '' && objGuardar.nombreCategoriaPromocion != null">
                      Se debe colocar nombre de la categoria de la promoción
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback :state="$v.objGuardar.nombreCategoriaPromocion.maxLength">
                      El nombre a ingresar no debe exceder los 50 caracteres.
                    </b-form-invalid-feedback>
                  </b-col>
                </b-col>
                <b-col cols="12" md="5" lg="5">
                  <b-col>
                    <b-form-group align="left">
                      <label class="letter">Descripción de la categoria promoción <validacion/> </label>
                      <b-input-group size="sm">
                        <b-form-textarea
                            class="redondeo"
                            id="descripcionCategoriaPromocion"
                            placeholder="Ingresa la descripción de la categoria promoción"
                            v-model="$v.objGuardar.descripcionCategoriaPromocion.$model"
                            :state="validateState('descripcionCategoriaPromocion')"
                            required
                            rows="3"
                            max-rows="4"
                        ></b-form-textarea>
                      </b-input-group>
                    </b-form-group>
                    <b-form-invalid-feedback :state="objGuardar.descripcionCategoriaPromocion != '' &&  objGuardar.descripcionCategoriaPromocion != null">
                      Se debe colocar descripción de la categoria de la promoción
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback :state="$v.objGuardar.descripcionCategoriaPromocion.maxLength">
                      La descripcion a ingresar no debe exceder los 100 caracteres.
                    </b-form-invalid-feedback>
                  </b-col>
                </b-col>
              </b-row>

              <div class="mt-2 col-md-12"></div>

            </div>
          </b-tab>
          <div class="text-center">
            <b-button
                class="mt-3 mr-4 botonesAzulFuerte"
                variant="primary"
                style="margin:10px"
                @click="$refs.submitGuardar.click()">Guardar
            </b-button>

            <b-button
                class="mt-3 ml-4 botonesGrisFuerte"
                style="margin:10px"
                @click="() => {$emit('cancelar')}">Cancelar
            </b-button>
          </div>
        </b-tabs>
      </div>
      <b-button v-show="false" id="submitGuardar" ref="submitGuardar" type="submit" style="visibility: hidden"></b-button>
    </b-form>
  </div>
</template>

<script>
import {maxLength, required} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";
export default {
  name: "altaCategoriaPromocion",
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      loading: false,
      objGuardar: {
        nombreCategoriaPromocion:null,
        descripcionCategoriaPromocion: null
      }
    }
  },
  props:{
    categoriaOriginal: Object,
  },
  mixins: [validationMixin],
  validations() {
    return {
      objGuardar: {
        nombreCategoriaPromocion: {required, maxLength: maxLength(50)},
        descripcionCategoriaPromocion:{required, maxLength: maxLength(100)}
      }
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.$nextTick(() => {
      this.$v.$reset()
    });
    if (this.categoriaOriginal != null && this.categoriaOriginal != undefined){
      this.objGuardar = JSON.parse(JSON.stringify(this.categoriaOriginal));
    }
  },
  methods: {
    validateState(name) {
      const {$dirty, $error} = this.$v.objGuardar[name];
      return $dirty ? !$error : null;
    },
    guardar() {
      this.$v.objGuardar.$touch();
      if (this.$v.objGuardar.$anyError) {
        return;
      }
      this.loading = true;

      this.$http
          .post(this.$api + "categoriaPromocion/guardarActualizarCategoriasPromocion", this.objGuardar)
          .then((response) => {
            if (response.status === 200) {
              this.$swal.fire({
                position: "center",
                icon: response.data.data != null ? "success" : "info",
                title: "Aviso",
                text: response.data.data != null ? "Categoria registrado correctamente" : response.data.message,
                showConfirmButton: false,
                timer: 3500,
              });
              if (response.data.data != null){
                this.$emit("actualizar", this.objGuardar);
              }

              this.$nextTick(() => {
                this.$v.$reset()
              });
            }
          }).catch((error)=>{
        console.error(error);
        this.$swal.fire({
          position: "center",
          icon: "error",
          title: "Ocurrio un error al registrar la categoria",
          showConfirmButton: false,
          timer: 3500,
        });
      }).finally(() => {
        this.loading = false;
        this.$emit('cancelar')
      });
    }
  }
}
</script>

<style scoped>
</style>
